import { atom } from 'jotai';

export const deletedAssetsAtom = atom<string[]>([]);
